import { phoneFormat } from '../../lib/script'
import classes from './FalseInputNumber.module.css'

const FalseInputNumber = ({label, value, minWidth, link, format}) => {


    return <div className={classes.container} style={{minWidth: minWidth}}>
        {!link && <div className={classes.container_inner}>
            {label && <div className={classes.label}>{label}</div>}
            {value && <div className={classes.input}>{(format && format == 'phone') ? phoneFormat(value) : value }</div>}
        </div>}
        {link && <a href={`${link.type ? `${link.type}:` : ''}${link.goto}`}><div className={classes.container_inner}>
            {label && <div className={classes.label}>{label}</div>}
            {value && <div className={classes.input}>{(format && format == 'phone') ? phoneFormat(value) : value}</div>}
        </div></a>}
    </div>
}

export default FalseInputNumber